export type UserRole = 'user' | 'admin';

export interface CurrentUserEntityProps {
  uuid: string;
  email: string;
  accountId: number;
  role: UserRole;
}

export class CurrentUserEntity {
  private readonly props: CurrentUserEntityProps;
  private constructor(props: CurrentUserEntityProps) { this.props = { ...props }; }
  static create(props: CurrentUserEntityProps) { return new CurrentUserEntity(props); }
  get uuid() { return this.props.uuid; }
  get email() { return this.props.email; }
  get accountId() { return this.props.accountId; }
  get role() { return this.props.role; }
  get isAdmin() { return this.props.role === 'admin'; }
}
